module.exports = __webpack_public_path__ + "static/natural-f861335584e0b5483b448976c78d637a.png";